<script>
    
    import { ShipmentStore, TicketStore, PickupStore } from '../stores'

    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

</script>

{#if $ShipmentStore}
    <div class="columns">
        <div class="column">
            <Value label="Proveedor" value={ $ShipmentStore.provider } />
        </div>
        <div class="column">
            <Value label="Servicio" value={ $ShipmentStore.service } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Guía" value={ $ShipmentStore.guide } />
        </div>
        <div class="column">
            <Value label="Documento" value="Descargar" icon="file-pdf" pointer link={ $ShipmentStore.document } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Número" value={ $ShipmentStore.number } prefix="#" />
        </div>
        <div class="column">
            <Value label="Estatus" value={ EnumMethods.get($ShipmentStore.status) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Precio de envío" value={ NumeralMethods.cash($ShipmentStore.pricing.shipmentPrice) } />
        </div>
        <div class="column">
            <Value label="Precio de seguro" value={ NumeralMethods.cash($ShipmentStore.pricing.insurancePrice) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Precio final" value={ NumeralMethods.cash($ShipmentStore.pricing.finalPrice) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de creación" value={ DateMethods.dateTimeLarge($ShipmentStore.created) } />
        </div>
        {#if $ShipmentStore.secret}
            <div class="column">
                <Value label="Código secreto" value={ $ShipmentStore.secret } />
            </div>
        {/if}
    </div>
    <br>
    {#if $ShipmentStore.tracking}
        <div class="title is-4">Estatus</div>
        <hr>
        <div class="columns">
            <div class="column">
                <Value label="Nombre" value={ $ShipmentStore.tracking.name } />
            </div>
            <div class="column">
                <Value label="Estatus" value={ EnumMethods.get($ShipmentStore.tracking.status) } />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Value label="Detalles" value={ $ShipmentStore.tracking.details } />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Value label="Fecha de creación" value={ DateMethods.dateTimeLarge($ShipmentStore.tracking.created) } />
            </div>
        </div>
        <br>
    {/if}
    <div class="title is-4">Paquete</div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Ancho" value={ $ShipmentStore.package.width } postfix="CM" />
        </div>
        <div class="column">
            <Value label="Alto" value={ $ShipmentStore.package.height } postfix="CM" />
        </div>
        <div class="column">
            <Value label="Largo" value={ $ShipmentStore.package.length } postfix="CM" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Valor" value={ NumeralMethods.cash($ShipmentStore.package.value) } />
        </div>
        <div class="column">
            <Value label="Peso físico" value={ $ShipmentStore.package.weight } postfix="KG" />
        </div>
        <div class="column">
            <Value label="Volumétrico" value={ $ShipmentStore.package.volumetric } postfix="KG" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Contenido" value={ $ShipmentStore.package.content } />
        </div>
    </div>
    <br>
    <div class="title is-4">Origen</div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Contacto" value={ $ShipmentStore.pickup.contact } />
        </div>
        <div class="column">
            <Value label="Correo" value={ $ShipmentStore.pickup.email } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="RFC" value={ $ShipmentStore.pickup.rfc } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Teléfono" value={ $ShipmentStore.pickup.phone } />
        </div>
        <div class="column">
            <Value label="Correo" value={ $ShipmentStore.pickup.email } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Código postal" value={ $ShipmentStore.pickup.zipcode } />
        </div>
        <div class="column">
            <Value label="Estado" value={ $ShipmentStore.pickup.state } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Ciudad" value={ $ShipmentStore.pickup.city } />
        </div>
        <div class="column">
            <Value label="Municipio" value={ $ShipmentStore.pickup.municipality } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Colonia" value={ $ShipmentStore.pickup.colony } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Calle" value={ $ShipmentStore.pickup.street } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Exterior" value={ $ShipmentStore.pickup.number } />
        </div>
        <div class="column">
            <Value label="Interior" value={ $ShipmentStore.pickup.apartment } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Referencias" value={ $ShipmentStore.pickup.references } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Entre calles" value={ $ShipmentStore.pickup.betweenStreets } />
        </div>
    </div>
    <br>
    <div class="title is-4">Destino</div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Contacto" value={ $ShipmentStore.delivery.contact } />
        </div>
        <div class="column">
            <Value label="Correo" value={ $ShipmentStore.delivery.email } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="RFC" value={ $ShipmentStore.delivery.rfc } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Teléfono" value={ $ShipmentStore.delivery.phone } />
        </div>
        <div class="column">
            <Value label="Correo" value={ $ShipmentStore.delivery.email } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Código postal" value={ $ShipmentStore.delivery.zipcode } />
        </div>
        <div class="column">
            <Value label="Estado" value={ $ShipmentStore.delivery.state } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Ciudad" value={ $ShipmentStore.delivery.city } />
        </div>
        <div class="column">
            <Value label="Municipio" value={ $ShipmentStore.delivery.municipality } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Colonia" value={ $ShipmentStore.delivery.colony } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Calle" value={ $ShipmentStore.delivery.street } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Exterior" value={ $ShipmentStore.delivery.number } />
        </div>
        <div class="column">
            <Value label="Interior" value={ $ShipmentStore.delivery.apartment } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Referencias" value={ $ShipmentStore.delivery.references } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Entre calles" value={ $ShipmentStore.delivery.betweenStreets } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Google Maps" value="Ver mapa" link={ `https://www.google.com/maps/search/?api=1&query=${$ShipmentStore.coordinates.lat},${$ShipmentStore.coordinates.lng}` } />
        </div>
    </div>
    <hr>
    <div class="columns">
        <div class="column">
            <Button on:click={() => PickupStore.modalCreate()} text="Agendar recolección" icon="calendar" fullwidth={true} />
        </div>
        <div class="column">
            <Button on:click={() => TicketStore.modalCreate()} text="Tuve un problema con mi envío" icon="exclamation-triangle" fullwidth={true} />
        </div>
    </div>
{/if}